// src/hooks/useSocket.js
import { COMMANDS } from '../../utils/commonProperties';
import * as THREE from 'three';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  resetOperation, setOperationData } from '../../redux/operationSlice';
import { generateUniqueId } from '../../utils/generateUniqueId';
import { createGroundingStrake } from '../../factory/symbols/createGroundingStrake';
 import useSnapPoints from '../../shared/snap/useSnapPoints';
import { useMPanelGroundWiring } from '../../modules/wiring';
  

const useMPanelGrounding = (scene, camera, renderer) => {
  const dispatch = useDispatch();
  const { commandType } = useSelector((state) => state.operation);
  const { snapPoints } = useSnapPoints(scene);

  const operation = useSelector((state) => state.operation);
   const dynamicSnapPoints = useRef([]);
  const wiringActiveRef = useRef(false);
  const sceneRef = useRef(null);
  const placedSocketsRef = useRef([]);
  // const { addTitleToScene } = useWireTitle();
  const masterNodeId = operation.data?.source?.masterNodeId
  const getOffsetPositionAtDirection = (base, direction, width = 14, height = 28) => {
    return base.clone().add(
      new THREE.Vector3(-direction.x * (width / 2), -direction.y * (height / 2), 0)
    );
  };

  const handleSocketPlace = (position, direction, rotation = 0) => {
    const adjustedPos = getOffsetPositionAtDirection(position, direction);
    const socket = createGroundingStrake(sceneRef.current, adjustedPos, direction, 0x0045ff, false, "normal", null, 135 + rotation); // 45 + 90 derece + r tuşu rotasyonu
    const angle = Math.atan2(direction.y, direction.x);
    socket.children[0].rotation.z = angle;

    socket.userData = {
      id: generateUniqueId(),
      type: 'groundingStrake',
      isSelectable: true,
      originalColor: 0x0045ff,
      connectedFrom: null,
      connectedTo: position.clone(),
    };

    sceneRef.current.add(socket);
    return socket;
  };

  const handleSocketRemove = (socket) => {
    if (!socket) return;
    sceneRef.current.remove(socket);
    socket.traverse(child => {
      if (child.geometry) child.geometry.dispose();
      if (child.material) child.material.dispose();
    });
  };
 
  const handlePreviewUpdate = (point) => {
    if (!sceneRef.current || !point || placedSocketsRef.current.length < 1) return;

    const lastSocket = placedSocketsRef.current[placedSocketsRef.current.length - 1];
    if (!lastSocket) return;

    const direction = new THREE.Vector3().subVectors(point, lastSocket.userData.connectedTo).normalize();
    const angle = Math.atan2(direction.y, direction.x);

    lastSocket.children[0].rotation.z = angle;
    lastSocket.position.copy(getOffsetPositionAtDirection(point, direction));
  };
 


  const handleWireEnd = (vertices, sockets, source, tempLineUUID) => {


    scene.traverse((obj) => {
      if (
        obj.type === 'Group' &&
        obj.userData?.type === 'groundingBuatLabel' &&
        obj.userData?.isPreview === true
      ) {
        obj.userData.isPreview = false;
      }
    });

          dispatch(resetOperation());
                wiringActiveRef.current = false;
   

  };








  useEffect(() => {
    if (commandType !== COMMANDS.DRAW_MPANEL_GROUNDING || !scene || !camera || !renderer) return;
  
    sceneRef.current = scene;

    // MainPanel merkez noktasından başlangıç noktası oluştur
    dynamicSnapPoints.current = [];
    let groundingStartPoint = null;
    
    scene.traverse(obj => {
      if (obj.userData?.type === 'mainPanel') {
        // MainPanel'in world pozisyonunu al
        const panelWorldPos = new THREE.Vector3();
        obj.getWorldPosition(panelWorldPos);
        const panelRotation = obj.rotation.z;
        
        // MainPanel'in giriş tarafından başlangıç noktası (rotation'a göre ters yön)
        const inputDirection = new THREE.Vector3(
          -Math.cos(panelRotation), // Giriş ters yönde
          -Math.sin(panelRotation),
          0
        );
        
        // Panel kenarından 7.5 birim geride (giriş wire'ı tarafı)
        groundingStartPoint = panelWorldPos.clone().add(inputDirection.clone().multiplyScalar(7.5));
        
        dynamicSnapPoints.current.push({
          no: obj.uuid,
          position: groundingStartPoint,
          type: 'mainPanelGrounding',
          panel: obj
        });
      }
      
      // Panel çıkış noktalarını da ekle (varsa)
      if (obj.userData?.connectionPoints) {
        obj.userData.connectionPoints.forEach(p => {
          if (p.type === 'panelCon_out') {
            const worldPos = p.position.clone().applyMatrix4(obj.matrixWorld);
            dynamicSnapPoints.current.push({
              no: obj.uuid,
              position: worldPos,
              type: 'panelConnection',
            });
          }
        });
      }
    });

    // Otomatik başlangıç noktası ayarla
    if (groundingStartPoint) {
      dispatch(setOperationData({
        commandType: COMMANDS.DRAW_MPANEL_GROUNDING,
        initialPoint: {
          x: groundingStartPoint.x,
          y: groundingStartPoint.y,
          z: groundingStartPoint.z
        },
        source: {
          type: 'mainPanelGrounding'
        }
      }));
    }

    wiringActiveRef.current = true;
  }, [commandType, scene, camera, renderer]);

  useMPanelGroundWiring(
    scene,
    camera,
    renderer,
    [...snapPoints, ...dynamicSnapPoints.current],
    {
      enabled: () => wiringActiveRef.current,
      onWireEnd: handleWireEnd,
      onSocketPlace: handleSocketPlace,
      onSocketRemove: handleSocketRemove,
      onPreviewUpdate: handlePreviewUpdate,
      onWireCancel: () => {
        wiringActiveRef.current = false; // ESC ile iptal edildiğinde devre dışı bırak
        dispatch(resetOperation()); // Redux state'i de sıfırla
      }
    }
  );
};

export default useMPanelGrounding; 